import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import { Link as TypographyLink } from "components/core/Typography";

import "./Link.scss";
import useClickTracking from "hooks/tracking/useClickTracking";

const Link = ({
	onClick = () => {},
	children,
	icon,
	href,
	reverse = false,
	className = null,
	hover = false,
	underline = false,
	target = "_self",
	color = "blue",
	...rest
}) => {
	const { handleClick } = useClickTracking({ onClick, href, target });

	const props = {
		onClick,
		target,
		href,
		color,
		className: classnames(
			"sf-link",
			{
				icon,
				reverse,
				hover,
				underline
			},
			className
		),
		...rest
	};

	return (
		<TypographyLink
			{...props}
			onClick={handleClick}
		>
			{icon ? (
				<>
					{icon}
					<span>{children}</span>
				</>
			) : (
				children
			)}
		</TypographyLink>
	);
};

Link.propTypes = {
	color: TypographyLink.propTypes.color,
	className: PropTypes.string,
	children: PropTypes.node.isRequired,
	reverse: PropTypes.bool,
	onClick: PropTypes.func,
	hover: PropTypes.bool,
	underline: PropTypes.bool,
	href: PropTypes.string.isRequired,
	icon: PropTypes.node,
	target: PropTypes.string
};

export default Link;
